<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="user_type == 'superadmin'">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-button
              @click="addUserModal"
              variant="primary"
              class="btn btn-success btn-sm"
            >
              <i class="mdi mdi-plus mr-1"></i>
              {{ $t("button.add.text") }}</b-button
            >
            <b-modal
              id="modal-add"
              centered
              :title="$t('button.add.text')"
              title-class="font-18"
              :ok-title="$t('button.save.text')"
              :cancel-title="$t('button.cancel.text')"
              @ok="addUser"
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="validationCustom01">{{
                      $t("form.user-management.label.username")
                    }}</label>
                    <input
                      id="validationCustom01"
                      type="text"
                      class="form-control"
                      :placeholder="
                        $t('form.user-management.placeholder.username')
                      "
                      v-model="form.user.username"
                      :class="{
                        'is-invalid': submitted && $v.form.user.username.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.user.username.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.user.username.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="validationCustom01">{{
                      $t("form.user-management.label.email")
                    }}</label>
                    <input
                      id="validationCustom01"
                      type="email"
                      class="form-control"
                      :placeholder="
                        $t('form.user-management.placeholder.email')
                      "
                      v-model="form.user.email"
                      :class="{
                        'is-invalid': submitted && $v.form.user.email.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.user.email.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.user.email.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="validationCustom02">{{
                      $t("form.user-management.label.user-type")
                    }}</label>
                    <select
                      class="custom-select"
                      v-model="form.user.user_type"
                      :class="{
                        'is-invalid': submitted && $v.form.user.user_type.$error,
                      }"
                    >
                      <option value="superadmin">Super Admin</option>
                      <option value="admin">Admin</option>
                      <option value="manager">Manager</option>
                      <option value="analys">Analys</option>
                    </select>
                    <div
                      v-if="submitted && $v.form.user.user_type.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.user.user_type.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="validationCustom01">{{
                      $t("form.user-management.label.password")
                    }}</label>
                    <input
                      id="validationCustom01"
                      type="password"
                      class="form-control"
                      :placeholder="
                        $t('form.user-management.placeholder.password')
                      "
                      v-model="form.user.password"
                      :class="{
                        'is-invalid': submitted && $v.form.user.password.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.user.password.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.user.password.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="validationCustom01">{{
                      $t("form.user-management.label.active-until")
                    }}</label>
                    <input
                      id="validationCustom01"
                      type="date"
                      class="form-control"
                      placeholder="active_until"
                      v-model="form.user.active_until"
                      :class="{
                        'is-invalid':
                          submitted && $v.form.user.active_until.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.user.active_until.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.user.active_until.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </b-modal>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("table.show-label") }}&nbsp;&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      class="mx-1"
                    ></b-form-select
                    >&nbsp;&nbsp;{{ $t("table.entri-label") }}
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("button.search.label") }}:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      :placeholder="$t('navbar.search.text')"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                bordered
                striped
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(username)="row">
                  <!-- {{row.item.avatar }} -->
                  <img
                    :src="urlImage + row.item.avatar"
                    class="mr-3 rounded-circle avatar-xs"
                    alt="user-pic"
                  />
                  {{ row.item.username }}
                </template>
                <template #cell(user_type)="row">
                  <span
                    class="badge badge-success rounded p-1 px-1 badge-md"
                    variant="success"
                    v-if="row.item.user_type == 'manager'"
                  >
                    Manager</span
                  >
                  <span
                    class="badge badge-info rounded p-1 px-1"
                    v-else-if="row.item.user_type == 'superadmin'"
                  >
                    Super Admin</span
                  >
                  <span
                    class="badge badge-primary rounded p-1 px-1"
                    v-else-if="row.item.user_type == 'analys'"
                  >
                    Analys</span
                  >
                  <span
                    class="badge badge-warning rounded p-1 px-1"
                    v-else-if="row.item.user_type == 'admin'"
                  >
                    Admin</span
                  >
                  <span class="badge badge-light rounded p-1 px-1" v-else>
                    {{ row.item.user_type }}</span
                  >
                </template>
                <template #cell(is_active)="row">
                  <span
                    class="p-1 px-1 text-success"
                    v-if="row.item.is_active == '1'"
                  >
                    <i class="fa fa-check"></i>
                  </span>
                  <span class="p-1 px-1 text-danger" v-else
                    ><i class="fa fa-times"></i
                  ></span>
                </template>
                <template #cell(actions)="row">
                  <b-button
                    title="Edit User"
                    @click="
                      editUser(
                        row.item.id_user,
                        row.item.username,
                        row.item.email,
                        row.item.is_active,
                        row.item.user_type,
                        row.item.active_until
                      )
                    "
                    class="btn btn-sm mr-1 mb-1"
                    variant="info"
                    ><i class="bx bx-pencil"></i
                  ></b-button>
                  <b-modal
                    ref="ref-modal-edit"
                    :id="'modal-edit' + row.item.id_user"
                    centered
                    :title="$t('button.update.text')"
                    title-class="font-18"
                    :ok-title="$t('button.update.text')"
                    :cancel-title="$t('button.cancel.text')"
                    @ok="updateUser($event, row.item.id_user)"
                  >
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="validationCustom01">{{
                            $t("form.user-management.label.username")
                          }}</label>
                          <input
                            id="validationCustom01"
                            type="text"
                            class="form-control"
                            :placeholder="
                              $t('form.user-management.placeholder.username')
                            "
                            v-model="form.user.username"
                            :class="{
                              'is-invalid':
                                submitted && $v.form.user.username.$error,
                            }"
                          />
                          <div
                            v-if="submitted && $v.form.user.username.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.form.user.username.required">{{
                              $t("form.error.text")
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="validationCustom01">{{
                            $t("form.user-management.label.email")
                          }}</label>
                          <input
                            id="validationCustom01"
                            type="email"
                            class="form-control"
                            :placeholder="
                              $t('form.user-management.placeholder.email')
                            "
                            v-model="form.user.email"
                            :class="{
                              'is-invalid':
                                submitted && $v.form.user.email.$error,
                            }"
                          />
                          <div
                            v-if="submitted && $v.form.user.email.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.form.user.email.required">{{
                              $t("form.error.text")
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="validationCustom02">{{
                            $t("form.user-management.label.user-type")
                          }}</label>
                          <select
                            class="custom-select"
                            v-model="form.user.user_type"
                            :class="{
                              'is-invalid':
                                submitted && $v.form.user.user_type.$error,
                            }"
                          >
                            <option value="superadmin">Super Admin</option>
                            <option value="admin">Admin</option>
                            <option value="manager">Manager</option>
                            <option value="analys">Analys</option>
                          </select>
                          <div
                            v-if="submitted && $v.form.user.user_type.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.form.user.user_type.required">{{
                              $t("form.error.text")
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="validationCustom02">{{
                            $t("form.user-management.label.active")
                          }}</label>
                          <select
                            class="custom-select"
                            v-model="form.user.is_active"
                            :class="{
                              'is-invalid':
                                submitted && $v.form.user.is_active.$error,
                            }"
                          >
                            <option value="1">Active</option>
                            <option value="0">Non Active</option>
                          </select>
                          <div
                            v-if="submitted && $v.form.user.is_active.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.form.user.is_active.required">{{
                              $t("form.error.text")
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="validationCustom01">{{
                            $t("form.user-management.label.active-until")
                          }}</label>
                          <input
                            id="validationCustom01"
                            type="date"
                            class="form-control"
                            v-model="form.user.active_until"
                            :class="{
                              'is-invalid':
                                submitted && $v.form.user.active_until.$error,
                            }"
                          />
                          <div
                            v-if="submitted && $v.form.user.active_until.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.form.user.active_until.required">{{
                              $t("form.error.text")
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-modal>
                  <b-button
                    class="mr-1 btn-sm mb-1"
                    title="Delete User"
                    variant="danger"
                    @click="deleteUser(row.item.id_user)"
                  >
                    <i class="bx bx-trash"></i>
                  </b-button>
                  <b-button
                    class="mr-2 btn-sm mb-1"
                    title="Change Password"
                    variant="secondary"
                    @click="changePassword(row.item.id_user)"
                  >
                    <i class="bx bx-key"></i>
                    <b-modal
                      ref="ref-modal-change-pass"
                      :id="'modal-change-password' + row.item.id_user"
                      centered
                      :title="$t('button.update.text')"
                      title-class="font-18"
                      :ok-title="$t('button.update.text')"
                      :cancel-title="$t('button.cancel.text')"
                      @ok="updatePassword($event, row.item.id_user)"
                      @hidden="resetForm"
                    >
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label for="validationCustom01">{{
                              $t("form.user-management.label.new_password")
                            }}</label>
                            <div class="input-group">
                              <input
                                :type="show.new ? 'text' : 'password'"
                                class="form-control"
                                placeholder="*******"
                                v-model="form.pass.new_password"
                                :class="{
                                  'is-invalid':
                                    submitted &&
                                    $v.form.pass.new_password.$error,
                                }"
                              />
                              <div class="input-group-prepend">
                                <span class="input-group-text">
                                  <div v-if="show.new">
                                    <i
                                      @click="show.new = false"
                                      class="fas fa-eye-slash"
                                    ></i>
                                  </div>
                                  <div v-else>
                                    <i
                                      @click="show.new = true"
                                      class="fas fa-eye"
                                    ></i>
                                  </div>
                                </span>
                              </div>
                              <div
                                v-if="
                                  submitted && $v.form.pass.new_password.$error
                                "
                                class="invalid-feedback"
                              >
                                <span
                                  v-if="!$v.form.pass.new_password.required"
                                  >{{ $t("form.error.text") }}</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <label for="validationCustom01">{{
                              $t("form.user-management.label.confirm_password")
                            }}</label>
                            <div class="input-group">
                              <input
                                :type="show.conf ? 'text' : 'password'"
                                class="form-control"
                                placeholder="*******"
                                v-model="form.pass.confirm_password"
                                :class="{
                                  'is-invalid':
                                    submitted &&
                                    $v.form.pass.confirm_password.$error,
                                }"
                              />
                              <div class="input-group-prepend">
                                <span class="input-group-text">
                                  <div v-if="show.conf">
                                    <i
                                      @click="show.conf = false"
                                      class="fas fa-eye-slash"
                                    ></i>
                                  </div>
                                  <div v-else>
                                    <i
                                      @click="show.conf = true"
                                      class="fas fa-eye"
                                    ></i>
                                  </div>
                                </span>
                              </div>
                              <div
                                v-if="
                                  submitted &&
                                    $v.form.pass.confirm_password.$error
                                "
                                class="invalid-feedback"
                              >
                                <span
                                  v-if="!$v.form.pass.confirm_password.required"
                                  >{{ $t("form.error.text") }}</span
                                >
                                <span
                                  v-if="
                                    !$v.form.pass.confirm_password
                                      .sameAsPassword &&
                                      $v.form.pass.confirm_password.required
                                  "
                                  >{{ $t("form.error.match") }}</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-modal>
                  </b-button>
                </template>
              </b-table>
            </div>
            <div class="row" v-if="rows > 10">
                <div class="col-2 col-xl-1">
                    <!-- <div v-if="selected[0]">
                      <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                    </div> -->
                    <label class="d-inline-flex align-items-center">
                      Page
                      <b-form-input
                        v-model="currentPage"
                        placeholder="Page"
                        class="form-control w-10 form-control ml-2"
                      ></b-form-input>
                    </label>
                </div>
                <div class="col-10 col-xl-11 text-right" v-if="rows > 10">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required, sameAs } from "vuelidate/lib/validators";
import UserService from "@/helpers/user.service";
import store from '@/state/store';
import moment from "moment";

export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      urlImage: process.env.VUE_APP_BASE_API_URL_AVATAR,
      user_type: '',
      tableData: [],
      title: this.$t("menuitems.user_management.text"),
      items: [
        {
          text: this.$t("menuitems.application.text"),
          href: "#",
        },
        {
          text: this.$t("menuitems.user_management.text"),
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
      fields: [
        { key: "no",  class: 'text-center', thStyle: { width: "2%" }, label:'No'},
        { key: "id_user", thClass: "d-none", tdClass: "d-none" },
        {
          key: "username",
          sortable: true,
          label: this.$t("table.user-management.th.username"),
        },
        {
          key: "email",
          sortable: true,
          label: this.$t("table.user-management.th.email"),
        },
        {
          key: "user_type",
          sortable: true,
          label: this.$t("table.user-management.th.user-type"),
        },
        { key: "avatar", thClass: "d-none", tdClass: "d-none" },
        {
          key: "is_active",
          sortable: true,
          label: this.$t("table.user-management.th.active"),
        },
        {
          key: "active_until",
          sortable: true,
          label: this.$t("table.user-management.th.active-until"),
        },
        {
          key: "created_at",
          sortable: true,
          label: this.$t("table.user-management.th.created-at"),
        },
        {
          key: "updated_at",
          sortable: true,
          label: this.$t("table.user-management.th.updated-at"),
        },
        {
          key: "actions",
          class: "text-center",
          label: this.$t("table.user-management.th.action"),
        },
      ],
      form: {
        user: {
          username: "",
          email: "",
          password: "",
          active_until: "",
          user_type: "",
          is_active: 0,
        },
        pass: {
          new_password: "",
          confirm_password: "",
        },
      },
      show: {
        new: false,
        conf: false,
      },
      submitted: false,
    };
  },
  validations: {
    form: {
      user: {
        username: { required },
        email: { required },
        active_until: { required },
        password: { required },
        user_type: { required },
        is_active: {},
      },
      pass: {
        new_password: { required },
        confirm_password: { required, sameAsPassword: sameAs("new_password") },
      },
    },
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  methods: {
      list() {
      UserService.getProfile()
      .then(response => {
        this.user_type = response.data.data.user_type
      })
      .catch(e => {
        this.message = e.response.data.data
      });
    },
    getUser() {
      UserService.getAllUser()
        .then((response) => {
          this.tableData = [];
          response.data.data.forEach((val, index) => {
            const data = {
              no: index+1,
              id_user: val.id_user,
              username: val.username,
              email: val.email,
              user_type: val.user_type,
              is_active: val.is_active,
              avatar: val.avatar,
              active_until: val.active_until,
              created_at: this.formatDate(val.created_at),
              updated_at: this.formatDate(val.updated_at),
            };
            this.tableData.push(data);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    addUserModal(){
        this.$bvModal.show('modal-add')
        this.form.user.username = "";
        this.form.user.email = "";
        this.form.user.active_until = "";
        this.form.user.user_type = "";
        this.form.user.password = "";
    },

    addUser(e) {
      this.submitted = true;
      this.$v.form.user.$touch();
      if (
        this.form.user.username == "" ||
        this.form.user.email == "" ||
        this.form.user.active_until == "" ||
        this.form.user.user_type == "" ||
        this.form.user.password == ""
      ) {
        e.preventDefault();
      } else {
        const data = {
          username: this.form.user.username,
          user_type: this.form.user.user_type,
          email: this.form.user.email,
          active_until: this.form.user.active_until,
          password: this.form.user.password,
          is_active: this.form.user.is_active,
        };

        UserService.addUser(data)
          .then((response) => {
            this.getUser();
            Vue.swal({
              position: "top-end",
              icon: "success",
              title: response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.resetForm();
            this.$v.$reset();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    editUser(id_user, username, email, is_active, user_type, active_until) {
      this.$bvModal.show("modal-edit" + id_user);
      this.form.user.username = username;
      this.form.user.email = email;
      this.form.user.is_active = is_active;
      this.form.user.user_type = user_type;
      this.form.user.active_until = active_until;
    },

    updateUser(e, id) {
      this.submitted = true;
      this.$v.form.user.$touch();
      if (this.form.user.username == "" || this.form.user.email == "") {
        e.preventDefault();
      } else {
        UserService.updateUser(id, this.form.user)
          .then((response) => {
            this.getUser();
            Vue.swal({
              position: "top-end",
              icon: "success",
              title: response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.resetForm();
            this.$v.$reset();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    deleteUser(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          UserService.deleteUser(id)
            .then((response) => {
              this.getUser();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    changePassword(id_user) {
      this.$bvModal.show("modal-change-password" + id_user);
    },
    updatePassword(e, id) {
      this.submitted = true;
      this.$v.form.pass.$touch();
      if (this.$v.form.pass.$invalid) {
        e.preventDefault();
      } else {
        // console.log('new pass->', this.form.pass.new_password);
        UserService.updatePassword(id, this.form.pass)
          .then((response) => {
            this.getUser();
            Vue.swal({
              position: "top-end",
              icon: "success",
              title: response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.$v.$reset();
            this.resetForm();
          })
          .catch((err) => {
            console.log(err);
            this.$v.$reset();
            this.resetForm();
          });
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onDelete(id) {
      console.log("delete data:", id);
    },
    onView(id) {
      console.log("details data:", id);
    },
    resetForm() {
      setTimeout(() => {
        this.form.user.username = "";
        this.form.user.email = "";
        this.form.user.password = "";
        this.form.user.user_type = "";
        this.form.user.active_until = "";
        this.form.user.is_active = false;
        this.form.pass.new_password = "";
        this.form.pass.confirm_password = "";
      }, 2000);
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD hh:mm");
    },
  },
  beforeMount(){
    this.list();
  },
  mounted() {
    this.totalRows = this.items.length;
    this.getUser();
  },
};
</script>

<style scoped>
.badge {
  border-radius: 2%;
}
.btn {
  border-radius: 7%;
}
</style>
